// extracted by mini-css-extract-plugin
export default {"answer":"interested_rows-module___answer___f74c9490","row":"interested_rows-module___row___f95286fe","statement":"interested_rows-module___statement___aa28723e"};